import VisibilityIcon from "@mui/icons-material/Visibility"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import IconButton from "@mui/material/IconButton"
import InputAdornment from "@mui/material/InputAdornment"
import TextField from "@mui/material/TextField"
import PropTypes from "prop-types"
import { useState } from "react"

export default function PasswordTextField({
  value,
  onChange,
  label,
  error,
  helperText,
  size,
  required,
  fullWidth,
  sx,
  onKeyDown,
  disabled,
  autoFocus,
  InputProps,
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false)

  const mergedInputProps = {
    ...(InputProps || {}),
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={() => setShowPassword(!showPassword)}
          edge="end"
          tabIndex={-1}
        >
          {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
        </IconButton>
      </InputAdornment>
    ),
  }

  return (
    <TextField
      label={label}
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      size={size}
      required={required}
      fullWidth={fullWidth}
      sx={sx}
      onKeyDown={onKeyDown}
      disabled={disabled}
      autoFocus={autoFocus}
      InputProps={mergedInputProps}
      {...rest}
    />
  )
}

PasswordTextField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.oneOf(["small", "medium"]),
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  sx: PropTypes.any,
  onKeyDown: PropTypes.func,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  InputProps: PropTypes.object,
}
